import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Group, X } from "lucide-react";

export function GroupSuggestionsDialog({ open, onOpenChange, suggestions, onAccept, onReject, onAcceptAll }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="group-suggestions-dialog">
        <DialogHeader>
          <DialogTitle>Suggested Groupings</DialogTitle>
          <DialogDescription>AI-suggested clusters based on relationships and naming. Nothing is applied until you accept.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {suggestions.map((s, i) => (
            <div key={i} data-testid={`group-suggestion-card-${i}`} className="border rounded-lg p-3 space-y-2 bg-slate-50">
              <div className="flex items-center gap-2">
                <Group size={14} className="text-slate-500" />
                <span className="font-semibold text-sm">{s.name}</span>
              </div>
              <div className="text-xs text-muted-foreground">{s.element_names.join(", ")}</div>
              <div className="flex gap-2 justify-end">
                <Button
                  size="sm"
                  variant="outline"
                  data-testid={`group-suggestion-reject-${i}`}
                  onClick={() => onReject(i)}
                >
                  <X size={13} className="mr-1" />
                  Dismiss
                </Button>
                <Button size="sm" data-testid={`group-suggestion-accept-${i}`} onClick={() => onAccept(i)}>
                  Group These
                </Button>
              </div>
            </div>
          ))}
          {suggestions.length === 0 && (
            <div className="text-sm text-muted-foreground text-center py-6">No suggestions left to review</div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="group-suggestions-close-button">
            Close
          </Button>
          {suggestions.length > 1 && (
            <Button onClick={onAcceptAll} data-testid="group-suggestions-accept-all-button">
              Accept All
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
